import { DateInput, TextInput } from '@frontend/components/basic-forms';
import { ActionModal } from '@frontend/components/modal';
import { IntervalSelect } from '@frontend/components/select';
import { CommonMessage } from '@frontend/lang';
import { MultiUserSelect } from '@frontend/user/select';
import { FormattedMessage } from 'react-intl';

import { useCreateScheduleModal } from './create-schedule-modal.controller';

export interface CreateScheduleModalProps {
    report_id: string;
}

export const CreateScheduleModal = (props: CreateScheduleModalProps) => {
    const viewProps = useCreateScheduleModal(props);
    return (
        <ActionModal
            title={CommonMessage.OBJECTS.SCHEDULE.DEFAULT}
            confirm={{ onConfirm: () => viewProps.onSubmit(), label: CommonMessage.OBJECTS.SCHEDULE.DEFAULT }}
            cancel={{ onCancel: () => viewProps.onCancel(), label: CommonMessage.BUTTONS.CANCEL }}>
            <div className='inline-flex flex-col items-start justify-start gap-4 self-stretch'>
                <div className="text-brand-muted justify-start self-stretch font-['Montserrat'] text-base font-medium">
                    <FormattedMessage
                        id='create-schedule-modal.description'
                        defaultMessage='Schedule a report to be sent to your mailbox.'
                    />
                </div>
                <div className='flex flex-col items-start justify-start gap-2 self-stretch'>
                    <TextInput
                        required
                        label={CommonMessage.OBJECTS.COMMON_FIELDS.NAME}
                        value={viewProps.formValues.name}
                        onChange={(e) => viewProps.setFormValues((prev) => ({ ...prev, name: e }))}
                    />
                    <IntervalSelect onChange={(e) => viewProps.setFormValues((prev) => ({ ...prev, every_days: e }))} />
                    <DateInput
                        label={
                            <FormattedMessage
                                id='create-schedule-modal.start-date'
                                defaultMessage='Start date'
                            />
                        }
                        submitted={false}
                        value={viewProps.formValues.initial_execution_timestamp ? new Date(viewProps.formValues.initial_execution_timestamp) : undefined}
                        onChange={(e) => viewProps.setFormValues((prev) => ({ ...prev, initial_execution_timestamp: e?.toISOString() }))}
                    />
                    <MultiUserSelect
                        label={CommonMessage.OBJECTS.TRANSACTION.RECEIVERS}
                        value={viewProps.formValues.receivers || []}
                        onChange={(e) => viewProps.setFormValues((prev) => ({ ...prev, receivers: e }))}
                    />
                </div>
            </div>
        </ActionModal>
    );
};
